import {
    AMARON__EVENT__CALLS__ACTION_PLATFORM__COLUMN_ID,
    AMARON__EVENT__CALLS__CALL_STATUS__COLUMN_ID,
    AMARON__EVENT__CALLS__LAST_CALL_DATE__COLUMN_ID,
    AMARON__EVENT__CALLS__LAST_DISPOSITION__COLUMN_ID,
    AMARON__EVENT__CALLS__LOGGED_BY__COLUMN_ID,
    AMARON__EVENT__CALLS__LOGGED_ON__COLUMN_ID,
    AMARON__EVENT__CALLS__REMARKS__COLUMN_ID,
    AMARON__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID,
    AMARON__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID,
    AMARON__EVENT__CALLS__FAD_CAMPAIGN_ID__COLUMN_ID,
    AMARON__EVENT__CALLS__FAD_SOURCE__COLUMN_ID,
    AMARON__EVENT__CALLS__FBCLID__COLUMN_ID,
    AMARON__EVENT__CALLS__FBRAID__COLUMN_ID,
    AMARON__EVENT__CALLS__GAD_CAMPAIGN_ID__COLUMN_ID,
    AMARON__EVENT__CALLS__GAD_SOURCE__COLUMN_ID,
    AMARON__EVENT__CALLS__GBRAID__COLUMN_ID,
    AMARON__EVENT__CALLS__GCLID__COLUMN_ID,
    AMARON__EVENT__CALLS__UTM_PLATFORM__COLUMN_ID,
    AMARON__EVENT__CALLS__UTM_SOURCE__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__AD_NAME__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__AD_SET_NAME__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__CAR_MAKE__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__CAR_MODEL__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__CONTACT_NUMBER__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__CUSTOMER_CITY__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__CUSTOMER_HOUSE_NO__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__CUSTOMER_NAME__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__CUSTOMER_STATE__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__CUSTOMER_VOC__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__ENQUIRY_STATUS__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__FUEL_TYPE__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__FAD_CAMPAIGN_ID__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__FAD_SOURCE__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__FBCLID__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__FBRAID__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__GAD_CAMPAIGN_ID__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__GAD_SOURCE__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__GBRAID__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__GCLID__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__SERVICE_REQUESTED__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__UTM_CAMPAIGN__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__UTM_CONTENT__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__UTM_MEDIUM__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__UTM_PLATFORM__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__UTM_SOURCE__COLUMN_ID,
    AMARON__EVENT__ENQUIRY__UTM_TERM__COLUMN_ID,
    AMARON__EVENT_CONTAINER__ACTION_PLATFORM__COLUMN_ID,
    AMARON__EVENT_CONTAINER__AD_NAME__COLUMN_ID,
    AMARON__EVENT_CONTAINER__AD_SET_NAME__COLUMN_ID,
    AMARON__EVENT_CONTAINER__CAR_MAKE__COLUMN_ID,
    AMARON__EVENT_CONTAINER__CAR_MODEL__COLUMN_ID,
    AMARON__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID,
    AMARON__EVENT_CONTAINER__CUSTOMER_CITY__COLUMN_ID,
    AMARON__EVENT_CONTAINER__CUSTOMER_HOUSE_NO__COLUMN_ID,
    AMARON__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID,
    AMARON__EVENT_CONTAINER__CUSTOMER_PLATFORM__COLUMN_ID,
    AMARON__EVENT_CONTAINER__CUSTOMER_STATE__COLUMN_ID,
    AMARON__EVENT_CONTAINER__CUSTOMER_VOC__COLUMN_ID,
    AMARON__EVENT_CONTAINER__FUEL_TYPE__COLUMN_ID,
    AMARON__EVENT_CONTAINER__FAD_CAMPAIGN_ID__COLUMN_ID,
    AMARON__EVENT_CONTAINER__FAD_SOURCE__COLUMN_ID,
    AMARON__EVENT_CONTAINER__FBCLID__COLUMN_ID,
    AMARON__EVENT_CONTAINER__FBRAID__COLUMN_ID,
    AMARON__EVENT_CONTAINER__GAD_CAMPAIGN_ID__COLUMN_ID,
    AMARON__EVENT_CONTAINER__GAD_SOURCE__COLUMN_ID,
    AMARON__EVENT_CONTAINER__GBRAID__COLUMN_ID,
    AMARON__EVENT_CONTAINER__GCLID__COLUMN_ID,
    AMARON__EVENT_CONTAINER__SERVICE_REQUESTED__COLUMN_ID,
    AMARON__EVENT_CONTAINER__UTM_CAMPAIGN__COLUMN_ID,
    AMARON__EVENT_CONTAINER__UTM_CONTENT__COLUMN_ID,
    AMARON__EVENT_CONTAINER__UTM_MEDIUM__COLUMN_ID,
    AMARON__EVENT_CONTAINER__UTM_PLATFORM__COLUMN_ID,
    AMARON__EVENT_CONTAINER__UTM_SOURCE__COLUMN_ID,
    AMARON__EVENT_CONTAINER__UTM_TERM__COLUMN_ID,
    AmaronCallStatusEnum,
    AmaronEnquiryStatusEnum,
    AmaronEventTypes,
    // buildAmaronCallsEventSyntheticDispositionColumnValues,
} from "~/domainModels/workspaceSpecific/amaron";
import {AmaronEventContainerTypes} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/amaron/EventContainers";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {OttopilotEventTemplate} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventsWorkspaceCapability/domain/OttopilotEventTemplate";
import {FilterOperation} from "@vesta/vos-types/modules/workspaceLevel/domain/FilterOperation";
import {createEvent, getEventContainersWithEvents, updateEvent, type EventContainerWithEvents} from "~/utilities/apis/api";
import {dataResult, errorResult, type Result} from "@vesta/error-handling-remix/result";
import {uniqueUuid} from "@vesta/unique/unique";

export const AMARON_OTTOPILOT_PLATFORM_VALUE = "ottopilot";

/** Log/schedule must not write UTM fields on call events (preserve ingest-only values). */
export function omitAmaronCallEventUtmFields(
    additionalColumnValues: Record<string, unknown>,
): Record<string, unknown> {
    const next: Record<string, unknown> = {...additionalColumnValues};
    delete next[AMARON__EVENT__CALLS__UTM_PLATFORM__COLUMN_ID];
    delete next[AMARON__EVENT__CALLS__UTM_SOURCE__COLUMN_ID];
    delete next[AMARON__EVENT__CALLS__GAD_SOURCE__COLUMN_ID];
    delete next[AMARON__EVENT__CALLS__GAD_CAMPAIGN_ID__COLUMN_ID];
    delete next[AMARON__EVENT__CALLS__GBRAID__COLUMN_ID];
    delete next[AMARON__EVENT__CALLS__GCLID__COLUMN_ID];
    delete next[AMARON__EVENT__CALLS__FAD_SOURCE__COLUMN_ID];
    delete next[AMARON__EVENT__CALLS__FAD_CAMPAIGN_ID__COLUMN_ID];
    delete next[AMARON__EVENT__CALLS__FBRAID__COLUMN_ID];
    delete next[AMARON__EVENT__CALLS__FBCLID__COLUMN_ID];
    return next;
}

function readNonEmptyString(raw: unknown): string | null {
    if (typeof raw !== "string") {
        return null;
    }
    const trimmed = raw.trim();
    if (trimmed === "") {
        return null;
    }
    return trimmed;
}

function readNonEmptyScalarString(raw: unknown): string | null {
    if (typeof raw === "string") {
        return readNonEmptyString(raw);
    }
    if (typeof raw === "number" || typeof raw === "boolean") {
        const asText = String(raw).trim();
        return asText === "" ? null : asText;
    }
    return null;
}

/** Customer platform on the lead — preserve existing value only; default for new leads from Ottopilot. */
export function resolveAmaronCustomerPlatformFromJourney(
    journeyAdditionalColumnValues: Record<string, unknown> | undefined,
): string {
    if (journeyAdditionalColumnValues === undefined) {
        return AMARON_OTTOPILOT_PLATFORM_VALUE;
    }
    const customerPlatform = readNonEmptyString(
        journeyAdditionalColumnValues[AMARON__EVENT_CONTAINER__CUSTOMER_PLATFORM__COLUMN_ID],
    );
    if (customerPlatform !== null) {
        return customerPlatform;
    }
    return AMARON_OTTOPILOT_PLATFORM_VALUE;
}

/** Journey fields updated whenever a call is logged or scheduled from Ottopilot. */
export function buildAmaronCallJourneyActivityColumnUpdate(args: {
    journeyAdditionalColumnValues?: Record<string, unknown>;
}): Record<string, unknown> {
    return {
        [AMARON__EVENT_CONTAINER__ACTION_PLATFORM__COLUMN_ID]: AMARON_OTTOPILOT_PLATFORM_VALUE,
        [AMARON__EVENT_CONTAINER__CUSTOMER_PLATFORM__COLUMN_ID]: resolveAmaronCustomerPlatformFromJourney(
            args.journeyAdditionalColumnValues,
        ),
    };
}

export function buildAmaronLoggedCallEventColumnUpdate(args: {
    disposition: Uuid;
    remarks: string;
    now: string;
    workspaceUserId: Uuid;
}): Record<string, unknown> {
    return {
        [AMARON__EVENT__CALLS__CALL_STATUS__COLUMN_ID]: AmaronCallStatusEnum.LOGGED,
        [AMARON__EVENT__CALLS__LAST_DISPOSITION__COLUMN_ID]: args.disposition,
        // ...buildAmaronCallsEventSyntheticDispositionColumnValues(args.disposition),
        [AMARON__EVENT__CALLS__REMARKS__COLUMN_ID]: args.remarks,
        [AMARON__EVENT__CALLS__LOGGED_BY__COLUMN_ID]: args.workspaceUserId,
        [AMARON__EVENT__CALLS__LOGGED_ON__COLUMN_ID]: args.now,
        [AMARON__EVENT__CALLS__LAST_CALL_DATE__COLUMN_ID]: args.now,
        [AMARON__EVENT__CALLS__ACTION_PLATFORM__COLUMN_ID]: AMARON_OTTOPILOT_PLATFORM_VALUE,
    };
}

export function buildAmaronScheduledCallEventColumnUpdate(args: {
    scheduledOnIso: string;
    workspaceUserId: Uuid;
}): Record<string, unknown> {
    return {
        [AMARON__EVENT__CALLS__CALL_STATUS__COLUMN_ID]: AmaronCallStatusEnum.SCHEDULED,
        [AMARON__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID]: args.scheduledOnIso,
        [AMARON__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID]: args.workspaceUserId,
        [AMARON__EVENT__CALLS__ACTION_PLATFORM__COLUMN_ID]: AMARON_OTTOPILOT_PLATFORM_VALUE,
    };
}

/** Earliest enquiry event on the journey (by `createdAt`). */
export function findFirstAmaronEnquiryEventOnJourney(
    journey: EventContainerWithEvents,
): EventContainerWithEvents["events"][number] | null {
    const enquiryTemplateId = String(AmaronEventTypes.Enquiry);
    const journeyEvents = journey.events ?? [];
    const enquiryEvents = journeyEvents.filter((event) => String(event.templateId) === enquiryTemplateId);
    if (enquiryEvents.length === 0) {
        return null;
    }
    return [...enquiryEvents].sort((left, right) => {
        if (left.createdAt < right.createdAt) {
            return -1;
        }
        if (left.createdAt > right.createdAt) {
            return 1;
        }
        return 0;
    })[0] ?? null;
}

export function buildAmaronFirstEnquiryEngagedStatusColumnUpdate(): Record<string, unknown> {
    return {
        [AMARON__EVENT__ENQUIRY__ENQUIRY_STATUS__COLUMN_ID]: AmaronEnquiryStatusEnum.ENGAGED as Uuid,
    };
}

const JOURNEY_TO_ENQUIRY_EVENT_COLUMN_PAIRS: ReadonlyArray<readonly [Uuid, Uuid]> = [
    [AMARON__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID, AMARON__EVENT__ENQUIRY__CUSTOMER_NAME__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID, AMARON__EVENT__ENQUIRY__CONTACT_NUMBER__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__CUSTOMER_STATE__COLUMN_ID, AMARON__EVENT__ENQUIRY__CUSTOMER_STATE__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__CUSTOMER_CITY__COLUMN_ID, AMARON__EVENT__ENQUIRY__CUSTOMER_CITY__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__CUSTOMER_HOUSE_NO__COLUMN_ID, AMARON__EVENT__ENQUIRY__CUSTOMER_HOUSE_NO__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__CUSTOMER_VOC__COLUMN_ID, AMARON__EVENT__ENQUIRY__CUSTOMER_VOC__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__CAR_MAKE__COLUMN_ID, AMARON__EVENT__ENQUIRY__CAR_MAKE__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__CAR_MODEL__COLUMN_ID, AMARON__EVENT__ENQUIRY__CAR_MODEL__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__FUEL_TYPE__COLUMN_ID, AMARON__EVENT__ENQUIRY__FUEL_TYPE__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__SERVICE_REQUESTED__COLUMN_ID, AMARON__EVENT__ENQUIRY__SERVICE_REQUESTED__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__AD_NAME__COLUMN_ID, AMARON__EVENT__ENQUIRY__AD_NAME__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__AD_SET_NAME__COLUMN_ID, AMARON__EVENT__ENQUIRY__AD_SET_NAME__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__UTM_PLATFORM__COLUMN_ID, AMARON__EVENT__ENQUIRY__UTM_PLATFORM__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__UTM_SOURCE__COLUMN_ID, AMARON__EVENT__ENQUIRY__UTM_SOURCE__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__UTM_MEDIUM__COLUMN_ID, AMARON__EVENT__ENQUIRY__UTM_MEDIUM__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__UTM_CAMPAIGN__COLUMN_ID, AMARON__EVENT__ENQUIRY__UTM_CAMPAIGN__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__UTM_TERM__COLUMN_ID, AMARON__EVENT__ENQUIRY__UTM_TERM__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__UTM_CONTENT__COLUMN_ID, AMARON__EVENT__ENQUIRY__UTM_CONTENT__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__GAD_SOURCE__COLUMN_ID, AMARON__EVENT__ENQUIRY__GAD_SOURCE__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__GAD_CAMPAIGN_ID__COLUMN_ID, AMARON__EVENT__ENQUIRY__GAD_CAMPAIGN_ID__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__GBRAID__COLUMN_ID, AMARON__EVENT__ENQUIRY__GBRAID__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__GCLID__COLUMN_ID, AMARON__EVENT__ENQUIRY__GCLID__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__FAD_SOURCE__COLUMN_ID, AMARON__EVENT__ENQUIRY__FAD_SOURCE__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__FAD_CAMPAIGN_ID__COLUMN_ID, AMARON__EVENT__ENQUIRY__FAD_CAMPAIGN_ID__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__FBRAID__COLUMN_ID, AMARON__EVENT__ENQUIRY__FBRAID__COLUMN_ID],
    [AMARON__EVENT_CONTAINER__FBCLID__COLUMN_ID, AMARON__EVENT__ENQUIRY__FBCLID__COLUMN_ID],
];

function mergeJourneyColumnsIntoEnquiryEventColumns(
    journeyAdditionalColumnValues: Record<string, unknown>,
): Record<string, unknown> {
    const out: Record<string, unknown> = {};
    for (const pair of JOURNEY_TO_ENQUIRY_EVENT_COLUMN_PAIRS) {
        const journeyColumnId = pair[0];
        const eventColumnId = pair[1];
        const raw = journeyAdditionalColumnValues[journeyColumnId];
        const asText = readNonEmptyScalarString(raw);
        if (asText === null) {
            continue;
        }
        out[eventColumnId] = raw;
    }
    return out;
}

export function buildAmaronEnquiryEventColumnValuesForNewJourney(args: {
    journeyAdditionalColumnValues: Record<string, unknown>;
    extraEnquiryEventColumns?: Record<string, unknown>;
}): Record<string, unknown> {
    const out: Record<string, unknown> = mergeJourneyColumnsIntoEnquiryEventColumns(
        args.journeyAdditionalColumnValues,
    );
    if (args.extraEnquiryEventColumns !== undefined) {
        for (const entry of Object.entries(args.extraEnquiryEventColumns)) {
            const columnId = entry[0];
            const value = entry[1];
            out[columnId] = value;
        }
    }
    out[AMARON__EVENT__ENQUIRY__ENQUIRY_STATUS__COLUMN_ID] = AmaronEnquiryStatusEnum.ENGAGED as Uuid;
    return out;
}

/**
 * When scheduling or logging a call creates a new journey, create an enquiry event with Engaged status.
 */
export async function createAmaronEnquiryForNewJourney(args: {
    accessToken: string;
    intellsysBaseUrl: string;
    workspaceId: Uuid;
    eventTemplates: Array<OttopilotEventTemplate>;
    journeyId: Uuid;
    journeyAdditionalColumnValues: Record<string, unknown>;
    extraEnquiryEventColumns?: Record<string, unknown>;
}): Promise<Result<Uuid>> {
    const enquiryEventTemplate = args.eventTemplates.find((template) => {
        return template.id === (AmaronEventTypes.Enquiry as Uuid);
    });
    if (enquiryEventTemplate === undefined) {
        return errorResult(new Error("Amaron enquiry event template is not configured for this workspace."));
    }

    const enquiryEventColumns = buildAmaronEnquiryEventColumnValuesForNewJourney({
        journeyAdditionalColumnValues: args.journeyAdditionalColumnValues,
        extraEnquiryEventColumns: args.extraEnquiryEventColumns,
    });

    return createEvent({
        accessToken: args.accessToken,
        intellsysBaseUrl: args.intellsysBaseUrl,
        workspaceId: args.workspaceId,
        event: {
            templateId: enquiryEventTemplate.id,
            eventContainerId: args.journeyId,
            additionalColumnValues: enquiryEventColumns,
        },
    });
}

function shouldMarkAmaronEnquiryEventAsEngaged(currentStatusRaw: unknown): boolean {
    if (currentStatusRaw === null || currentStatusRaw === undefined) {
        return true;
    }
    const currentStatus = readNonEmptyScalarString(currentStatusRaw);
    if (currentStatus === null) {
        return true;
    }
    if (currentStatus === String(AmaronEnquiryStatusEnum.ENGAGED)) {
        return false;
    }
    if (currentStatus === String(AmaronEnquiryStatusEnum.ARCHIVE)) {
        return false;
    }
    return true;
}

async function resolveAmaronEventContainerWithEventsForEnquiryMark(args: {
    journey: EventContainerWithEvents;
    accessToken: string;
    intellsysBaseUrl: string;
    workspaceId: Uuid;
}): Promise<EventContainerWithEvents> {
    const journeyWithNormalizedEvents: EventContainerWithEvents = {
        ...args.journey,
        events: args.journey.events ?? [],
    };
    if (findFirstAmaronEnquiryEventOnJourney(journeyWithNormalizedEvents) !== null) {
        return journeyWithNormalizedEvents;
    }

    const journeysResult = await getEventContainersWithEvents({
        workspaceId: args.workspaceId,
        templateId: AmaronEventContainerTypes.Journeys as Uuid,
        limit: 1,
        offset: 0,
        filterConfiguration: {
            revisionId: uniqueUuid`c8f4a2e1-6b3d-4f9a-8e2c-1d5a7b9e0f3c`,
            lineItems: [
                {
                    columnId: "id",
                    operation: FilterOperation.equals,
                    value: args.journey.id,
                },
            ],
        },
        sortConfiguration: {
            revisionId: uniqueUuid`d9e5b3f2-7c4e-5a0b-9f3d-2e6b8c0a1d4f`,
            lineItems: [],
        },
        intellsysBaseUrl: args.intellsysBaseUrl,
        accessToken: args.accessToken,
    });
    if (journeysResult.success === true && journeysResult.data.length > 0) {
        const fetched = journeysResult.data[0]!;
        return {
            ...fetched,
            events: fetched.events ?? [],
        };
    }

    return journeyWithNormalizedEvents;
}

/**
 * When scheduling or logging a call on an existing journey, set the first enquiry event to Engaged.
 */
export async function markAmaronFirstEnquiryEventEngagedOnExistingJourney(args: {
    journey: EventContainerWithEvents;
    accessToken: string;
    intellsysBaseUrl: string;
    workspaceId: Uuid;
}): Promise<Result<void>> {
    const journeyWithEvents = await resolveAmaronEventContainerWithEventsForEnquiryMark(args);
    const firstEnquiryEvent = findFirstAmaronEnquiryEventOnJourney(journeyWithEvents);
    if (firstEnquiryEvent === null) {
        return dataResult(undefined);
    }

    const currentStatus =
        firstEnquiryEvent.additionalColumnValues[AMARON__EVENT__ENQUIRY__ENQUIRY_STATUS__COLUMN_ID];
    if (shouldMarkAmaronEnquiryEventAsEngaged(currentStatus) !== true) {
        return dataResult(undefined);
    }

    return updateEvent({
        accessToken: args.accessToken,
        intellsysBaseUrl: args.intellsysBaseUrl,
        workspaceId: args.workspaceId,
        eventId: firstEnquiryEvent.id,
        templateId: AmaronEventTypes.Enquiry as Uuid,
        data: buildAmaronFirstEnquiryEngagedStatusColumnUpdate() as never,
    });
}
